/**
 * src/hooks/useAssistantMonth.ts
 *
 * アシスタントページ全体で表示月を共有するフック。
 * - assistant_id をキーに localStorage に保存するため、
 *   複数ユーザーが同一ブラウザを使っても混在しない。
 * - リロードしても月が保持される。
 * - JST基準の当月をデフォルト値にする。
 *
 * 使い方:
 *   const [month, setMonth] = useAssistantMonth(user?.assistant_id)
 */

import { useState } from 'react'
import { thisMonthJst } from '../utils/jst'

const KEY_PREFIX = 'mangaos_asst_month'

function storageKey(assistantId: string | null | undefined): string {
  return assistantId ? `${KEY_PREFIX}_${assistantId}` : KEY_PREFIX
}

function readMonth(assistantId: string | null | undefined): string {
  try {
    const s = localStorage.getItem(storageKey(assistantId))
    if (s && /^\d{4}-\d{2}$/.test(s)) return s
  } catch { /* ignore */ }
  return thisMonthJst()
}

function writeMonth(assistantId: string | null | undefined, month: string): void {
  try {
    localStorage.setItem(storageKey(assistantId), month)
  } catch { /* ignore */ }
}

export function useAssistantMonth(
  assistantId: string | null | undefined,
): [string, (m: string) => void] {
  const [month, setMonthState] = useState<string>(() => readMonth(assistantId))

  const setMonth = (m: string) => {
    setMonthState(m)
    writeMonth(assistantId, m)
  }

  return [month, setMonth]
}
